module.exports = __webpack_public_path__ + "static/media/MTL_SL_BOSS3.d1b9f049.png";